import api from '@/helpers/api'
import { createNamespacedHelpers } from 'vuex'
export const { mapState, mapMutations, mapActions } = createNamespacedHelpers('banner')

import Utils from "@/helpers/utils.js";

export default {
  namespaced: true,
  state: {
    banners: [],
  },
  mutations: {
    setBanners: (state, data) => {
      try {
        state.banners = Utils.sortData(_.map(data, v => {
            v['sub_title'] = v['sub_title'].replace(/(?:\r\n|\r|\n)/g, '<BR/>')
            return v
          }))
      } catch(e) { 
        state.banners = []
      }
      // console.log("banners :", state.banners)
    },
  },
  actions: {
    getBanners: async ({commit}) => {
      try {
        const response = await api.get('banner/list')
        commit('setBanners', response.data)
      } catch (e) {
        console.error('[axios] getBanners :', e.message)
      }
    },
    
  }
}